import {FC} from "react";
import {Link} from "../../../ui";
import {ServicesInform} from "../";
import styled from "styled-components";
import useDrawer from "../../../hooks/useDrawer";
import Loading from "../../../ui/Loading/Loading";
import {LoadingIcon} from "../../../ui/Icons";
import {useGetServicesByIdQuery} from "./__generated__/ServicesRoot.query.generated";

const Options = styled.div`
  h2 {
    font-weight: 400;
    color: ${props => props.theme.palette.purple};
  }
  ul {
    display: flex;
    flex-direction: column;
  }
`;

const ServicesRoot:FC = () => {
  const { id, openChildrenHandler } = useDrawer();
  const { data, loading, error } = useGetServicesByIdQuery({ variables: { id }});

  if (loading || !data) {
    return (
      <Loading><LoadingIcon /></Loading>
    );
  }

  if (error) {
    return <p>{error.message}</p>;
  }

  if (!data?.getServiceById) {
    return <p>Возможно произошла ошибка или ID был пуст</p>;
  }

  return (
     <>
       <ServicesInform
         info={data?.getServiceById}
       />
       <Options>
         <h2>Управление категорией</h2>
         <ul>
           <Link colorTheme="green" onClick={() => openChildrenHandler('servicesSettingsEdit')}>Редактировать сервис</Link>
           <Link colorTheme="red" onClick={() => openChildrenHandler('servicesSettingsDelete')}>Удалить сервис</Link>
         </ul>
       </Options>
     </>
  )
}

export default ServicesRoot;
